import PropTypes from 'prop-types'
import React from 'react'
import 'react-vis/dist/style.css'
import {
  makeWidthFlexible,
  XYPlot,
  XAxis,
  YAxis,
  HorizontalGridLines,
  AreaSeries,
  MarkSeries,
  LineSeries,
  Hint
} from 'react-vis'
import { connectivityLogForCharts } from 'modules/farmhand'
import { ConnectivityLogShape } from 'shapes'
import AreaHint from 'components/area-hint'
import ChartHintTimestamp from 'components/chart-hint-timestamp'

const FlexibleXYPlot = makeWidthFlexible(XYPlot)

const HistoricalDataShape = PropTypes.arrayOf(PropTypes.shape({
  fullValue: PropTypes.number.isRequired,
  timestamp: PropTypes.object.isRequired
}))

class SensorChart extends React.PureComponent {
  static propTypes = {
    data: HistoricalDataShape.isRequired,
    sensor: PropTypes.object.isRequired,
    xStart: PropTypes.string.isRequired,
    xEnd: PropTypes.string.isRequired,
    highlighted: PropTypes.shape({
      x: PropTypes.instanceOf(Date).isRequired,
      y: PropTypes.number.isRequired
    }),
    highlightX: PropTypes.func.isRequired,
    connectivityData: PropTypes.arrayOf(ConnectivityLogShape)
  }

  static defaultProps = {
    connectivityData: []
  }

  state = {
    isFocused: false
  }

  mouseEnterHandler = () => {
    this.setState({ isFocused: true })
  }

  mouseLeaveHandler = () => {
    this.props.highlightX(null)
    this.setState({ isFocused: false })
  }

  render () {
    const {
      data,
      connectivityData,
      sensor,
      highlighted,
      highlightX,
      xStart,
      xEnd
    } = this.props
    const { isFocused } = this.state

    const formattedData = data.map(({ fullValue, timestamp }) => {
      return {
        x: timestamp,
        y: fullValue / sensor.formatter
      }
    })

    const yValues = formattedData.map((value) => value.y)

    const minY = Math.min.apply(null, yValues)
    const maxY = Math.max.apply(null, yValues)
    const yOffset = (maxY - minY) / 2
    const offsetMax = maxY + yOffset
    const offsetMin = minY - yOffset
    const offsetMinZero = offsetMin < 0 ? 0 : offsetMin

    const yDomain = offsetMin === offsetMax ? [0, offsetMax * 2] : [offsetMinZero, offsetMax]

    // not sure why this reverse() works -- it shouldn't need it but for some reason it does
    const formattedConnectivityData = connectivityLogForCharts(xStart, xEnd, connectivityData).reverse().map(({createdAt, sensorsOnline}) => {
      return {
        x: createdAt,
        y: !sensorsOnline ? yDomain[1] : yDomain[0]
      }
    })

    return (
      <FlexibleXYPlot
        height={180}
        xType="time"
        onMouseMove={this.mouseEnterHandler}
        onMouseLeave={this.mouseLeaveHandler}
        xDomain={[new Date(xStart), new Date(xEnd)]}
        yDomain={yDomain}
      >
        <HorizontalGridLines />
        <AreaSeries
          stroke="#21CABA"
          fill="rgba(33, 202, 186, 0.25)"
          data={formattedData}
          onNearestX={highlightX}
        />
        <AreaSeries
          stroke="none"
          fill="rgba(255,255,255, 0.9)"
          data={formattedConnectivityData}
          curve="curveStepAfter"
        />
        <XAxis tickTotal={6} />
        <YAxis tickPadding={-1} />
        {highlighted ? (
          <LineSeries
            data={[
              {x: highlighted.x, y: yDomain[0]},
              {x: highlighted.x, y: yDomain[1]}
            ]}
            stroke="rgba(17,147,154,0.7)"
            strokeWidth={2}
          />
        ) : null}
        {highlighted && isFocused ? (
          <MarkSeries
            fill="#509F96"
            stroke="#509F96"
            data={[highlighted]}
          />
        ) : null}
        {highlighted && isFocused ? (
          <Hint value={highlighted}>
            <AreaHint>
              <ChartHintTimestamp timestamp={highlighted.x} />
              <p><em>{highlighted.y}{sensor.unit}</em></p>
            </AreaHint>
          </Hint>
        ) : null}
      </FlexibleXYPlot>
    )
  }
}

export default SensorChart



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/sensor-chart/index.js